import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import IconLink from '../../assets/Images/icons/icon-link.svg';
import { Form } from 'antd';
//Service
import DataCatalogService from '../../services/DataCatalog.service';

//Components
import ModalSync from './components/ModalSync';
import Loading from './components/Loading';
import useNotify from '../../context/Notification/useNotify';
import usePermission from '../../hooks/usePermission';

export function DataCatalog() {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [open, setOpen] = useState(false);
    const notify = useNotify();
    const [responseData, setResponseData] = useState([]);
    const [dataSelection, setDataSelection] = useState([]);
    const [catalogTitle, setCatalogTitle] = useState();
    const [modalData, setModalData] = useState();
    const [loading, setLoading] = useState(false);
    const [process, setProcess] = useState(0);
    const title = [
        {
            datasetDataCatalogName: 'Activity',
        },
        {
            datasetDataCatalogName: 'Personal Data',
        },
        {
            datasetDataCatalogName: 'Sensitive Data',
        },
    ];
    const changeDataSource = async (item, value) => {
        setLoading(true);
        setOpen(false);
        const Object = {
            datasetDataCatalogId: item?.datasetDataCatalogId,
            datasetDataCatalogName: item?.datasetDataCatalogName,
            sourceDataCatalogId: value?.dataCatalogId,
            sourceDataCatalogName: value?.dataCatalogName,
        };

        let time = 100;
        let start = 0;
        let waiting = 0;

        try {
            const startLoading = setInterval(() => {
                start += 1;
                if (start > 50 && waiting === 0) {
                    if (start > 80) {
                        waiting = 1;
                        start = 50;
                    }
                } else if (start === 90) {
                    time = 1000;
                } else {
                    setProcess(start);
                }
                if (start === 100) {
                    setProcess(0);
                    setLoading(false);
                    clearInterval(startLoading);
                    getDataCatalog();
                    notify({
                        title: t('common.Success'),
                        description: t('Successfully sync data'),
                        timeOut: 1800,
                    });
                }
            }, time);
            const { data } = await DataCatalogService.changeDataCatalog(Object);

            if (data?.resultCode === 0) {
                setProcess(0);
                setLoading(false);
                clearInterval(startLoading);
            }
        } catch (error) {
            console.log(error);
            setProcess(0);
            setLoading(false);
        }
    };

    const getDataCatalog = async () => {
        try {
            const { data } = await DataCatalogService.getDataCatalog();
            console.log(data?.resultData);
            setResponseData(data?.resultData);
            console.log(responseData);
        } catch (error) {
            console.log(error);
        }
    };

    const getDropDown = async (e) => {
        try {
            const { data } = await DataCatalogService.getDropDownDataCatalog();
            setDataSelection(data?.resultData);
        } catch (error) {
            console.log(error);
        }
    };

    useEffect(() => {
        getDataCatalog();
        getDropDown();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const { isAuditor, isUser } = usePermission();

    return (
        <>
            <div className="title ">Data Catalog</div>
            <div className="sub-title">
                <span className="text-sm text-gray-400">
                    {t('common.Configuration')} /
                </span>
                <span> Data Catalog Settings </span>
            </div>
            <div className="w-full bg-white rounded-xl px-14 py-8 my-4 space-y-10 h-full">
                <div style={{ borderBottom: '3px solid #F4F6FC' }}>
                    <div className="flex space-x-2 items-center pb-6">
                        <div className="text-2xl font-semibold text-[#7B67FB]">
                            Data Catalog Settings
                        </div>
                    </div>
                </div>
                <div className="space-y-10">
                    <div className="flex flex-row">
                        <div className="basis-[320px] font-semibold text-base">
                            <div className="grid-cols-1 space-y-3">
                                <div className="font-medium text-xl">
                                    Dataset
                                </div>
                                {responseData?.map((res) => (
                                    <div
                                        key={res?.datasetDataCatalogName}
                                        className="flex items-center"
                                    >
                                        <div className="w-[320px] p-5 bg-[#EDEEF9] border-solid border-[1px] rounded-md border-[#A9B2FF]">
                                            <div className="flex items-center space-x-2">
                                                <svg
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="6"
                                                        cy="6.5"
                                                        r="6"
                                                        fill="#4ACE8F"
                                                    />
                                                </svg>
                                                <span>
                                                    {
                                                        res?.datasetDataCatalogName
                                                    }
                                                </span>
                                            </div>
                                        </div>
                                        <div className="p-5">
                                            <img src={IconLink} alt="logo" />
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div className="basis-[320px] font-semibold text-base">
                            <div className="grid-cols-1 space-y-3">
                                <div className="font-medium text-xl">
                                    Source of data catalog
                                </div>
                                {responseData?.map((res, index) => (
                                    <div
                                        key={res.sourceDataCatalogName}
                                        className="flex items-center"
                                    >
                                        <div className="w-[320px] p-5 bg-[#EDEEF9] border-solid border-[1px] rounded-md border-[#A9B2FF]">
                                            <div className="flex items-center space-x-2">
                                                <svg
                                                    width="12"
                                                    height="13"
                                                    viewBox="0 0 12 13"
                                                    fill="none"
                                                    xmlns="http://www.w3.org/2000/svg"
                                                >
                                                    <circle
                                                        cx="6"
                                                        cy="6.5"
                                                        r="6"
                                                        fill="#4ACE8F"
                                                    />
                                                </svg>
                                                <span>
                                                    {res?.sourceDataCatalogName}
                                                </span>
                                            </div>
                                        </div>
                                        {res?.datasetDataCatalogName !==
                                            'Personal Data' &&
                                            res?.datasetDataCatalogName !==
                                                'Sensitive Data' && (
                                                <button
                                                    disabled={
                                                        isAuditor || isUser
                                                    }
                                                    onClick={() => {
                                                        setOpen(true);
                                                        setModalData(res);
                                                        setCatalogTitle(
                                                            title[index]
                                                                ?.datasetDataCatalogName
                                                        );
                                                    }}
                                                    className="disabled:opacity-50 disabled:cursor-not-allowed p-5 text-[#1890FF] hover:opacity-60 cursor-pointer duration-700"
                                                >
                                                    Change
                                                </button>
                                            )}
                                    </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ModalSync
                open={open}
                item={modalData}
                handelClose={() => setOpen(false)}
                setLoading={setLoading}
                changeDataSource={changeDataSource}
                dataSelection={dataSelection}
                form={form}
                title={catalogTitle}
            />
            <Loading
                open={loading}
                handelClose={() => setOpen(false)}
                process={process}
            />
        </>
    );
}
